export default {
  BOX_SHADOW: "0px 0px 1px 0.5px rgba(212, 205, 212, 1);",
  //BASE_URL: "http://datarecapture.premiumpension.com:8089/api",
  // Production URL
  BASE_URL: "https://mobile.premiumpension.com/multichannel/api",
  VALIDATION_BASE_URL:
    "https://fundfusion.premiumpension.com/wildfly/pensionserver-web/rest",
  VALIDATION_TEST_BASE_URL:
    "https://api.premiumpension.com/wildfly/pensionserver-web/rest",
  TIMEOUT: 30 * 1000,
  LOGOUT_IF_ERROR: "Token has expired.",
  RSA_PIN_2_PATH: "/rsapin-2",
  NETWORK_FAILED_ERROR: "Network request failed",
  FAILED_TO_FETCH: "Failed to fetch",
  VALIDATION_ERROR_MESSAGE: "Please fill all the mandatory fields",
  STAFF_CODE: 1,
  EMPLOYER_CODE: 2,
  AGENT_CODE: 3,
  MEMBER_CODE: 4,
  NON_MEMBER_CODE: 5,
  ALWAYS_ALLOWED_ROUTES: [
    "/rsapin-uba",
    "/rsapin-2",
    "/rsapin-3",
    "/rsapin-4",
    "/cyberpay-success",
  ],
  NON_PROTECTED_ROUTES: [
    "/login",
    "/register",
    "/privacypolicy",
    "/forgotpassword",
    "/newpassword",
    "/useractivation",
    "/rsapin-uba",
    "/rsapin-2",
    "/rsapin-3",
    "/rsapin-4",
    "/consentscreen",
    "/registration-token",
    "/cyberpay-success",
  ],
  FULL_SCREEN_ROUTES: [
    "/rsapin-uba",
    "/rsapin-2",
    "/rsapin-3",
    "/rsapin-4",
    "/cyberpay-success",
  ],
  MEMBER_RESTRICTED_ROUTES: [],
  STAFF_RESTRICTED_ROUTES: [],
  AGENT_RESTRICTED_ROUTES: [],
  NON_MEMBER_RESTRICTED_ROUTES: [
    // "onboarding",
    // "rsapin",
    "currentbalance",
    // "transactiondetails",
    "selfservice",
    "personaldetails",
    "nextofkin",
    "employeedetails",
    "changepassword",
    "addrole",
    "downloadforms",
    "contribution",
    "withdrawal",
  ],
  EMPLOYER_RESTRICTED_ROUTES: [
    // "currentbalance",
    // "transactiondetails",
    "selfservice",
    "nextofkin",
    "downloadforms",
    // "contribution",
    "withdrawal",
  ],
  BLOCKED_ROUTES: [""],
  SYSTEM_ACCOUNT: {
    USERNAME: "pplUbaSystem",
    EMAIL: "system@premiumpension.com",
    PASSWORD: "Today456",
  },
  GENDER: [
    { label: "Male", value: "M" },
    { label: "Female", value: "F" },
  ],
  MARITAL_STATUS_CODES: [
    {
      label: "Married",
      value: "MD",
    },
    {
      label: "Single",
      value: "SG",
    },
    {
      label: "Divorced",
      value: "DV",
    },
    {
      label: "Windowed",
      value: "WD",
    },
    {
      label: "Seperated",
      value: "SP",
    },
  ],
  testingDomains: ["fortewiz.com", "localhost"],
  NOTIFICATION_API_DEFAULT_EMAIL: "pplcontributions@premiumpension.com",
  isNINVerificationAPIConnected: true,

  MONTHS: {
    1: "jan",
    2: "feb",
    3: "mar",
    4: "apr",
    5: "may",
    6: "jun",
    7: "jul",
    8: "aug",
    9: "sept",
    10: "oct",
    11: "nov",
    12: "dec",
  },
  VALIDATION_ERROR_MESSAGE: "Please fill all the mandatory fields",
  userRole: {
    Staff: 1,
    Employer: 2,
    Agent: 3,
    Member: 4,
    "Non-Member": 5,
    Admin: 6,
  },
};
